module.exports = __webpack_public_path__ + "img/scarf.5a4c7dda.png";